import { useEffect } from 'react'

/**
 * Custom hook that triggers a callback when a key is pressed.
 *
 * @param {Function} callback - The callback function to execute when a key is pressed.
 * @param {string[]} keys - The keys to listen for and call the callback when pressed.
 */
export const useKeydown = (callback: (code: string) => void, keys: string[] = []) => {
  useEffect(() => {
    function handleKeyDown(e: { code: string }) {
      if (keys.includes(e.code)) callback(e.code)
    }

    document.addEventListener('keydown', handleKeyDown)

    return () => document.removeEventListener('keydown', handleKeyDown)
  }, [keys])
}
